import React, { useState, useEffect } from "react";
import "./MindGymSection.css";
import mg1 from '../assets/home_item/Links/Standee-Image.jpg';
import whatsapp from '../assets/images/whatsapp.png';
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';

const translationData = { en: en, mr: ma };

const MindGymSection = () => {
  const [language, setLanguage] = useState(() => getLanguage() || 'en');
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => { clearInterval(interval); window.removeEventListener('storage', checkLang); };
  }, []);

  return (
    <section className="mindgym-section">
      <div className="mindgym-container">

        {/* LEFT CONTENT */}
        <div className="mindgym-left">
          <p className="mindgym-eyebrow">{t('mindgym_eyebrow')}</p>
          <h2 className="mindgym-title">
            {t('mindgym_main_title')}
          </h2>

          <p className="mindgym-description">
            {t('mindgym_desc')}
          </p>

          <ul className="mindgym-list">
            <li>{t('mindgym_item1')}</li>
            <li>{t('mindgym_item2')}</li>
            <li>{t('mindgym_item3')}</li>
          </ul>

          <p className="mindgym-plan-text">{t('mindgym_plan_text')}</p>

          <div className="mindgym-tags">
            <span>{t('mindgym_tag_schools')}</span>
            <span>{t('mindgym_tag_colleges')}</span>
            <span>{t('mindgym_tag_corporates')}</span>
            <span>{t('mindgym_tag_senior')}</span>
            <span>{t('mindgym_tag_families')}</span>
          </div>

          <div className="mindgym-buttons">

            {/* ✅ Plan Your Visit */}
            <a
              href="https://mindgym.manashakti.org/#contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="plan-btn"
            >
              {t('mindgym_btn_visit')}
            </a>

            {/* ✅ WhatsApp Button */}
            <a
              href="https://api.whatsapp.com/send/?phone=9096800275&text=hi&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              <img
                src={whatsapp}
                alt="WhatsApp"
                className="whatsapp-icon"
              />
              {t('mindgym_btn_whatsapp')}
            </a>

          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="mindgym-right">
          <img
            src={"https://res.cloudinary.com/dtuy184dc/image/upload/v1775119485/Standee-Image_gyujkr.jpg"}
            alt="Mind Gym"
            className="mindgym-image"
          />
        </div>

      </div>
    </section>
  );
};

export default MindGymSection;